import { DataGridPro } from "@mui/x-data-grid-pro";
import {
  Box,
  Chip,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
} from "@mui/material";
import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import SideModal from "../../../components/SideModal";
import CompetencyPlaylistForm from "../../Playlist/Components/CompetencyPlaylistForm/CompetencyPlaylistForm";
import { useDispatch } from "react-redux";
import { fetchRecordedContactsInsights } from "../../../store/RecordedContactInsights/recordedContactsInsightsThunks";

function CompetencyReviewDatagrid({ rows, filters }) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [statusFilter, setStatusFilter] = useState("all");
  const [openCompetencyPlaylistForm, setOpenCompetencyPlaylistForm] =
    useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const statusColors = {
    not_yet_reviewed: "error",
    overdue: "error",
    due_soon: "warning",
    up_to_date: "success",
  };

  const statusLabels = {
    not_yet_reviewed: "Not Yet Reviewed",
    overdue: "Overdue",
    due_soon: "Due Soon",
    up_to_date: "Up to Date",
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "full_name", headerName: "Name", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
    { field: "function", headerName: "Function", flex: 0.8 },
    { field: "route", headerName: "Route", flex: 0.8 },
    { field: "area", headerName: "Area", flex: 0.8 },
    {
      field: "next_competency_review_due_at",
      headerName: "Review Due Date",
      flex: 1,
      renderCell: (params) => {
        const value = params.value;
        return value
          ? new Date(value).toLocaleDateString("en-GB")
          : "No Review Record";
      },
    },
    {
      field: "competency_status_category",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => {
        const status = params.value;
        const color = statusColors[status] || "default";
        const label = statusLabels[status] || status;
        return <Chip label={label} color={color} size="small" />;
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() => {
            setSelectedRow(params.row);
            setOpenCompetencyPlaylistForm(true);
          }}
          sx={{ color: theme.palette.text.primary }}
        >
          <HeadphonesIcon />
        </IconButton>
      ),
    },
  ];

  const filteredRows =
    statusFilter === "all"
      ? rows
      : rows.filter((row) => row.competency_status_category === statusFilter);

  return (
    <Box sx={{ height: 400, width: "100%" }}>
      <FormControl sx={{ mb: 2, minWidth: 200 }}>
        <InputLabel id="status-filter-label">
          Filter by Competency Status
        </InputLabel>
        <Select
          labelId="status-filter-label"
          value={statusFilter}
          label="Filter by Competency Status"
          onChange={(e) => setStatusFilter(e.target.value)}
          size="small"
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="not_yet_reviewed">Not Yet Reviewed</MenuItem>
          <MenuItem value="overdue">Overdue</MenuItem>
          <MenuItem value="due_soon">Due Soon</MenuItem>
          <MenuItem value="up_to_date">Up to Date</MenuItem>
        </Select>
      </FormControl>

      <DataGridPro
        rows={filteredRows}
        columns={columns}
        disableRowSelectionOnClick
        getRowHeight={() => "auto"}
        initialState={{
          sorting: {
            sortModel: [{ field: "full_name", sort: "asc" }],
          },
        }}
        sx={{
          backgroundColor: (theme) => theme.palette.background.paper,
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#f9f9f9",
            fontWeight: "bold",
          },
        }}
      />

      <SideModal
        open={openCompetencyPlaylistForm}
        onClose={() => setOpenCompetencyPlaylistForm(false)}
        title={
          selectedRow
            ? `Create Competency Playlist for ${selectedRow.full_name}`
            : "Create Competency Playlist"
        }
      >
        {selectedRow && (
          <CompetencyPlaylistForm
            row={selectedRow}
            onSubmit={(data) => {
              setOpenCompetencyPlaylistForm(false);
              dispatch(fetchRecordedContactsInsights(filters));
            }}
          />
        )}
      </SideModal>
    </Box>
  );
}

export default CompetencyReviewDatagrid;
